export const BROWSE_ASSESSMENTS_EVENT_NAMES = {
  RETURNED_RESULTS: 'Returned Browse Assessments Results',
  SELECTED_SUBJECT: 'Selected Browse Assessments Subject',
  REMOVED_SUBJECT: 'Removed Browse Assessments Subject',
  SELECTED_GRADE: 'Selected Browse Assessments Grade',
  UNSELECTED_GRADE: 'Unselected Browse Assessments Grade',
  SELECTED_CATEGORY: 'Selected Browse Assessments Category',
  UNSELECTED_CATEGORY: 'Unselected Browse Assessments Category',
  SELECTED_TYPE: 'Selected Browse Assessments Type',
  UNSELECTED_TYPE: 'Unselected Browse Assessments Type',
  SELECTED_LANGUAGE: 'Selected Browse Assessments Language',
  SEARCHED_KEYWORD: 'Searched Browse Assessments Keyword',
  CLEARED_KEYWORD: 'Cleared Browse Assessments Keyword',
  COMPLETED_WIZARD_RESULTS_STREAM: 'Completed Assessment Wizard Results Stream',
  VIEWED_PAGE: 'Viewed Browse Assessments Page',
  REMOVED_CATEGORY: 'Removed Browse Assessments Category',
  REMOVED_GRADE: 'Removed Browse Assessments Grade',
  REMOVED_TYPE: 'Removed Browse Assessments Type',
  REMOVED_LANGUAGE: 'Removed Browse Assessments Language',
  REMOVED_KEYWORD: 'Removed Browse Assessments Keyword',
  CLICKED_REFINE_SEARCH: 'Clicked Refine Search'
}
